import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';
import FormInput from '../../components/FormInput';
import AuthLayout from '../../components/Layout/AuthLayout';
import { navLinks } from '../../constants/paths';
import { useSetPasswordMutation } from '../../redux/services/auth';

const SetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Minimum 8 characters are required')
    .required('Password is required'),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Password must match',
  ),
});

const SetPassword = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [setPassword] = useSetPasswordMutation();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: SetPasswordSchema,
    onSubmit: async (values) => {
      const data = {
        token: searchParams.get('token'),
        password: values.password,
      };
      console.log(JSON.stringify(data));
      const res: any = await setPassword(data);
      if (res.data) {
        toast.success(t('new_password_success'));
        navigate('/auth/login');
      } else toast.error(res.error.data.message);
    },
  });

  const { errors, touched } = formik;
  return (
    <AuthLayout>
      <div className="lgBox">
        <h2>{t('help_reset_password')}</h2>

        <p>{t('reset_password_form_title')}</p>

        <form onSubmit={formik.handleSubmit}>
          <FormInput
            label={t('label_new_password')}
            type="password"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            touched={touched.password}
            error={errors.password}
          />

          <FormInput
            label={t('label_confirm_password')}
            type="password"
            name="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            touched={touched.confirmPassword}
            error={errors.confirmPassword}
          />

          <button type="submit" className="btn btn-primary w-100">
            {t('create_new_password')}
          </button>
        </form>

        <div className="form-group donthave">
          <p>
            <Link to={navLinks.login}>{t('btn_back_to_login')}</Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default SetPassword;
